<template>
  <div class="userinfo-container">
    <el-row>
      <el-col class="tcf-row">
        <div class="card">
          <div class="card-body">
            <el-tabs v-model="activeName">
              <el-tab-pane label="个人信息" name="first">
                <el-form ref="userinfoForm" :model="userinfoForm" :rules="rulesUserinfo" label-position="right" label-width="75px" size="medium">
                  <div style="margin: 0 auto;width: 60%">
                    <el-form-item label="头像">
                      <SingleImg ref="photo" v-model="userinfoForm.photo" :oldurl="user.photo" />
                    </el-form-item>
                    <el-form-item label="姓名">
                      <el-input :value="user.name" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="所属门店">
                      <el-input :value="user.delname" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="职位">
                      <el-input :value="user.positionname" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex">
                      <el-radio-group v-model="userinfoForm.sex">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="tel">
                      <el-input v-model="userinfoForm.tel" maxlength="11" minlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="导购员" prop="isshop">
                      <el-switch v-model="userinfoForm.isshop"></el-switch>
                      <span style="font-size: 12px;color: #9aaabf;margin-left: 10px">开启后将展示在门店小程序导购列表</span>
                    </el-form-item>
                    <el-form-item label="微信号">
                      <el-input v-model="userinfoForm.wchat"></el-input>
                    </el-form-item>
                    <el-form-item label="生日">
                      <el-select v-model="userinfoForm.bdtype" style="width:100px" placeholder="请选择">
                        <el-option
                          v-for="item in bdtypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-date-picker
                        v-model="userinfoForm.birthday"
                        type="date"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="邮箱">
                      <el-input v-model="userinfoForm.email"></el-input>
                    </el-form-item>
                    <el-form-item label="籍贯">
                      <el-cascader
                        style="width:300px"
                        v-model="userinfoForm.city"
                        :options="cityoptions"
                        filterable></el-cascader>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" :loading="isLoading" :disabled="isDisabled" @click="submitForm('userinfoForm')">{{ btnName }}</el-button>
                    </el-form-item>
                  </div>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="账号绑定" name="second">
                <ul class="account-bind-list">
                  <li>
                    <div class="bind-icon"><svg-icon icon-class="phone"/></div>
                    <div class="bind-mark">{{user.username.length>0?'[已绑定]'+phoneBindVal:'未绑定'}}</div>
                    <el-button :type="user.username.length>0?'':'primary'" size="small" @click="phoneBindVisible=true">{{user.username.length>0?'更换':'绑定'}}</el-button>
                  </li>
                  <li>
                    <div class="bind-icon wechat"><svg-icon icon-class="wechat"/></div>
                    <div class="bind-mark">{{user.unionid.length>0?'已绑定':'未绑定'}}</div>
                    <el-button @click="showWChatDialog" :type="user.unionid.length>0?'':'primary'" size="small">{{user.unionid.length>0?'重新绑定':'绑定'}}</el-button>
                  </li>
                  <li>
                    <div class="bind-icon alipay"><svg-icon icon-class="alipay"/></div>
                    <div class="bind-mark">{{user.zfbopenid.length>0?'已绑定':'未绑定'}}</div>
                    <el-button @click="showALiDialog" :type="user.zfbopenid.length>0?'':'primary'" size="small">{{user.zfbopenid.length>0?'重新绑定':'绑定'}}</el-button>
                  </li>
                </ul>
                <el-dialog
                  title="更换手机绑定"
                  :visible.sync="phoneBindVisible"
                  width="50%"
                  :lock-scroll="true"
                  :destroy-on-close="true"
                  :append-to-body="false">
                  <phoneBind @closePhoneBind="closePhoneBind" />
                </el-dialog>
              </el-tab-pane>
              <el-tab-pane label="修改密码" name="third">
                <el-steps :active="pawactive" finish-status="success" simple>
                  <el-step title="输入手机号码"></el-step>
                  <el-step title="短信验证码"></el-step>
                  <el-step title="修改密码"></el-step>
                </el-steps>
                <div style="margin: 0 auto;width: 60%;padding-top: 40px;">
                  <el-form ref="updatePawForm" :model="updatePawForm" :rules="rulesUpdatePaw" label-position="right" label-width="75px" size="medium">
                    <el-form-item label="手机号码" prop="username" v-show="pawactive==0">
                      <el-input v-model="updatePawForm.username" placeholder="请输入登录手机号码" maxlength="11" minlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code" v-show="pawactive==1" >
                      <el-input v-model="updatePawForm.code" style="width: 300px" placeholder="请输入短信验证码" maxlength="6" minlength="6"></el-input>
                      <el-button :disabled="isDisabledCode" :loading="isCodeLoading" @click="getCode(0)">{{codeBtn}}</el-button>
                    </el-form-item>
                    <el-form-item label="新密码" prop="password" v-show="pawactive==2" >
                      <el-input type="password" v-model="updatePawForm.password" placeholder="请输入新的密码" maxlength="16" minlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="refpassword" v-show="pawactive==2" >
                      <el-input type="password" v-model="updatePawForm.refpassword" placeholder="请再次输入新的密码" maxlength="16" minlength="6"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button v-show="pawactive!=0" @click="previousUpdatePaw()">上一步</el-button>
                      <el-button :loading="isCodeLoading" type="primary" @click="subUpdatePaw()">{{nextBtn}}</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-col>
      <el-dialog
        title="支付宝扫码授权"
        :visible.sync="aLiDialog"
        :before-close="closeALiPayTimer"
        width="300px"
      >
        <div style="height: 270px;padding: 20px 0 0 35px;" v-loading="aLiLoading">
          <div id="aLiPayLogin" ref="aLiPayLogin"/>
          <div v-if="aLiPayBad === true" class="pay-error">
            <p>获取二维码失败</p>
            <el-button type="primary" icon="el-icon-refresh-right" round @click="showALiDialog()">重新获取</el-button>
          </div>
          <div class="pay-expired" v-if="aLiPayTimeOut === true" >
            <p style="margin-top:70px;">该二维码已失效</p>
            <el-button style="margin-top: 20px;" type="primary" icon="el-icon-refresh-right" round @click="showALiDialog()">重新获取</el-button>
          </div>
          <div v-if="aLiPaySuccess === true" class="pay-success">
            <p><i class="el-icon-success" /> 扫码成功，正在登录</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="微信扫码授权"
        :visible.sync="wChatDialog"
        :before-close="closeWChatTimer"
        width="330px"
      >
        <wxlogin :appid="appid" :scope="wxScope" :redirect_uri="redirect_uri" :state="wxState" />
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { editDealerUserInfo } from '@/api/dealer'
import {
  getSMSCode,
  forgetPassword,
  getWChatToken,
  checkWChatToken,
  getALiPayToken,
  checkALiPayToken,
  getWchatOpenIdByCode
} from '@/api/pub'
import SingleImg from '@/components/upload/SingleImg'
import phoneBind from '@/views/my/phoneBind'
import { getCity } from '@/utils/city'
import { validatePhoneNumber } from '@/utils/validate'
import wxlogin from 'vue-wxlogin'
import { accountBinding } from '@/api/user'
import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'
import QRCode from 'qrcodejs2'
import { getUrlKey } from '@/utils'
export default {
  name: 'Userinfo',
  components: {
    SingleImg,
    phoneBind,
    wxlogin
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        if (this.user.username === value) {
          callback()
        } else {
          callback(new Error('此手机号与登录手机号不匹配'))
        }
      }
    }
    const validateCode = (rule, value, callback) => {
      if (rule.required) {
        if (value.length !== 6) {
          callback(new Error('请输入6位短信验证码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (rule.required) {
        if (value.length < 6) {
          callback(new Error('请输入6-16位的登录密码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateRefPassword = (rule, value, callback) => {
      if (rule.required) {
        if (value.length < 6) {
          callback(new Error('请输入6-16位的登录密码'))
        } else {
          if (value === this.updatePawForm.password) {
            callback()
          } else {
            callback(new Error('两次密码输入不一致'))
          }
        }
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      men: men,
      women: women,
      phoneBindVisible: false,
      phoneBindVal: '',
      pawactive: 0,
      isLoading: false,
      isCodeLoading: false,
      isDisabled: false,
      btnName: '立即修改',
      codeBtn: '重新获取 60',
      nextBtn: '下一步',
      isDisabledCode: true,
      codeTimer: '',
      sounds: 60,
      bdtypes: [
        {
          value: '0',
          label: '农历'
        },
        {
          value: '1',
          label: '公历'
        }
      ],
      cityoptions: getCity(),
      userinfoForm: {
        photo: null,
        tel: '',
        wchat: '',
        email: '',
        sex: '',
        bdtype: '',
        birthday: '',
        isshop: false,
        city: []
      },
      rulesUserinfo: {
        tel: [
          { required: true, trigger: 'change', validator: validateTel }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ]
      },
      updatePawForm: {
        username: '',
        msg_id: '',
        code: '',
        password: '',
        refpassword: ''
      },
      rulesUpdatePaw: {
        username: [{ required: true, trigger: 'change', validator: validateUsername }],
        code: [{ required: false, trigger: 'change', validator: validateCode }],
        password: [{ required: false, trigger: 'change', validator: validatePassword }],
        refpassword: [{ required: false, trigger: 'change', validator: validateRefPassword }]
      },
      appid: 'wx48ffbf1de47b1986',
      wxScope: 'snsapi_login',
      redirect_uri: 'https://www.mulu.life/elichain/my/dealerinfo',
      wxState: '',
      aLiPayToken: '',
      aLiDialog: false,
      aLiPayLoading: false,
      wChatDialog: false,
      aLiLoading: false,
      aLiPayTimeOut: false,
      aLiPaySuccess: false,
      aLiPayBad: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    const code = getUrlKey('code')
    const state = getUrlKey('state')
    if (code !== null && code !== '' && code !== undefined && state !== null && state !== '' && state !== undefined) {
      // 代表微信授权成功
      this.activeName = 'second'
      const wxloginLoading = this.$loading({
        lock: true,
        text: '微信绑定中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      getWchatOpenIdByCode({ code: code }).then(response => {
        if (response.data !== undefined && response.data !== null) {
          const data = {
            userid: this.user.userid,
            role: 1,
            type: 1,
            wxopenid: response.data.openid,
            wxunionid: response.data.unionid
          }
          accountBinding(data).then(response => {
            wxloginLoading.close()
            this.$message({
              type: 'success',
              message: '绑定成功'
            })
            this.user.unionid = response.data.unionid
            this.user.wxopenid = response.data.wxopenid
            sessionStorage.setItem('ElichainUser', JSON.stringify(this.user))
            this.wChatDialog = false
          }).catch(() => {
            wxloginLoading.close()
          })
        } else {
          this.$message.error('微信绑定失败')
          wxloginLoading.close()
        }
      }).catch(res => {
        wxloginLoading.close()
      })
    }
    this.phoneBindVal = this.user.username.substring(0, 3) + '****' + this.user.username.substring(7, 11)
    this.userinfoForm.tel = this.user.tel
    this.userinfoForm.wchat = this.user.wchat
    this.userinfoForm.email = this.user.email
    this.userinfoForm.sex = this.user.sex
    this.userinfoForm.bdtype = this.user.bdtype + ''
    this.userinfoForm.birthday = this.user.birthday
    this.userinfoForm.isshop = this.user.isshop === 1 ? true : false
    const oldcity = []
    if (this.user.province) {
      oldcity.push(this.user.province)
    }
    if (this.user.city) {
      oldcity.push(this.user.city)
    }
    if (this.user.county) {
      oldcity.push(this.user.county)
    }
    if (oldcity.length > 0) {
      this.userinfoForm.city = oldcity
    }
  },
  methods: {
    findALiPayToken() {
      const _this = this
      _this.aLiPayTimer = setInterval(function() {
        // 变成绑定的接口
        checkALiPayToken({ token: _this.aLiPayToken }).then(response => {
          if (response.data !== undefined && response.data !== null) {
            if (_this.aLiPayTimer !== null) {
              clearInterval(_this.aLiPayTimer)
              _this.aLiPayTimer = null
            }
            _this.user.zfbopenid = response.data
            const data = {
              userid: _this.user.userid,
              role: 1,
              type: 2,
              zfbopenid: response.data
            }
            accountBinding(data).then(response => {
              _this.$message({
                type: 'success',
                message: '绑定成功'
              })
              _this.aLiPaySuccess = true
              if (response.data.photo === null || response.data.photo === '') {
                if (response.data.sex === '男') {
                  response.data.photo = _this.men
                } else {
                  response.data.photo = _this.women
                }
              }
              sessionStorage.setItem('ElichainUser', JSON.stringify(response.data))
              _this.aLiDialog = false
            })
          }
        }).catch(() => {
          if (_this.aLiPayTimer !== null) {
            clearInterval(_this.aLiPayTimer)
            _this.aLiPayTimer = null
          }
          this.aLiPayBad = true
        })
      }, 1000)
    },
    closeALiPayTimer(done) {
      if (this.aLiPayTimer !== null) {
        clearInterval(this.aLiPayTimer)
        this.aLiPayTimer = null
      }
      done()
    },
    showWChatDialog() {
      this.wxState = new Date().getTime().toString()
      this.wChatDialog = true
      // getWChatToken().then(response => {
      //   this.wxState = response.data
      //   this.findWChatToken()
      // }).catch(res => {
      // })
    },
    findWChatToken() {
      const _this = this
      _this.wChatTimer = setInterval(function() {
        // 变成绑定微信的接口
        checkWChatToken({ token: _this.wxState }).then(response => {
          if (response.data !== undefined && response.data !== null) {
            if (_this.wChatTimer !== null) {
              clearInterval(_this.wChatTimer)
              _this.wChatTimer = null
            }
            const data = {
              userid: _this.user.userid,
              role: 1,
              type: 1,
              wxopenid: response.data.openid,
              wxunionid: response.data.unionid
            }
            accountBinding(data).then(response => {
              _this.$message({
                type: 'success',
                message: '绑定成功'
              })
              _this.user.unionid = response.data.unionid
              _this.user.wxopenid = response.data.wxopenid
              if (response.data.photo === null || response.data.photo === '') {
                if (response.data.sex === '男') {
                  response.data.photo = _this.men
                } else {
                  response.data.photo = _this.women
                }
              }
              sessionStorage.setItem('ElichainUser', JSON.stringify(response.data))
              _this.wChatDialog = false
            })
          }
        })
      }, 1000)
    },
    closeWChatTimer(done) {
      if (this.wChatTimer !== null) {
        clearInterval(this.wChatTimer)
        this.wChatTimer = null
      }
      done()
    },
    showALiDialog() {
      this.aLiDialog = true
      this.aLiLoading = true
      this.aLiPayBad = false
      this.aLiPaySuccess = false
      getALiPayToken().then(response => {
        this.$refs.aLiPayLogin.innerHTML = ''
        this.aLiPayToken = response.data
        const redirectUrl = `${this.$store.state.settings.ApiPath}api/getALiPayLogin?aLiPayToken=${this.aLiPayToken}`
        const url = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2019102468626149&scope=auth_user&redirect_uri=${redirectUrl}`
        this.aLiPayLogin = new QRCode('aLiPayLogin', {
          width: 200,
          height: 200,
          text: url,
          colorDark: '#000',
          colorLight: '#fff'
        })
        this.aLiLoading = false
        this.findALiPayToken()
      }).catch(() => {
        this.aLiLoading = false
        this.aLiPayBad = true
      })
    },
    closePhoneBind(tel) {
      this.phoneBindVal = tel.substring(0, 3) + '****' + tel.substring(7, 11)
      this.phoneBindVisible = false
    },
    submitForm(formName) {
      const _self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _self.isLoading = true
          _self.isDisabled = true
          _self.btnName = '修改中...'
          let province = ''
          let city = ''
          let county = ''
          let imgid = ''
          if (_self.userinfoForm.city.length === 3) {
            province = _self.userinfoForm.city[0]
            city = _self.userinfoForm.city[1]
            county = _self.userinfoForm.city[2]
          }
          if (_self.userinfoForm.photo != null) {
            imgid = _self.userinfoForm.photo.imgid
          }
          const data = {
            userid: _self.user.userid,
            imgid: imgid,
            tel: _self.userinfoForm.tel,
            wchat: _self.userinfoForm.wchat,
            email: _self.userinfoForm.email,
            sex: _self.userinfoForm.sex,
            bdtype: _self.userinfoForm.bdtype,
            birthday: _self.userinfoForm.birthday,
            province: province,
            city: city,
            county: county,
            isshop: _self.userinfoForm.isshop ? 1 : 0
          }
          editDealerUserInfo(data).then(response => {
            this.user.tel = data.tel
            this.user.wchat = data.wchat
            this.user.email = data.email
            this.user.sex = data.sex
            this.user.bdtype = data.bdtype
            this.user.birthday = data.birthday
            this.user.province = data.province
            this.user.city = data.city
            this.user.county = data.county
            this.user.isshop = data.isshop
            if (_self.userinfoForm.photo != null) {
              this.user.photo = _self.userinfoForm.photo.imgurl
            } else {
              if (this.user.photo === null || this.user.photo === '' || this.user.photo === '/photo_women.jpg' || this.user.photo === '/photo_men.jpg') {
                if (this.user.sex === '女') {
                  this.user.photo = '@/assets/login/photo_women.png'
                } else {
                  this.user.photo = '@/assets/login/photo_men.png'
                }
              }
            }
            sessionStorage.setItem('ElichainUser', JSON.stringify(this.user))
            _self.clearForm(formName)
            this.$confirm('建议你重新登录一下，免得让我为难好吗?', '个人信息修改成功', {
              confirmButtonText: '去登录',
              cancelButtonText: '关闭',
              type: 'success'
            }).then(() => {
              this.$store.dispatch('user/logout')
              this.$router.push(`/login`)
            }).catch(() => {
            })
          }).catch(() => {
            _self.clearForm(formName)
            return false
          })
        } else {
          return false
        }
      })
    },
    clearForm(formName) {
      this.isLoading = false
      this.isDisabled = false
      this.btnName = '立即修改'
    },
    subUpdatePaw() {
      if (this.pawactive === 0) {
        this.$refs['updatePawForm'].validate((valid) => {
          if (valid) {
            this.isDisabledCode = false
            this.getCode(1)
            this.rulesUpdatePaw.code[0].required = true
            this.$refs['updatePawForm'].clearValidate()
          } else {
            return false
          }
        })
      } else if (this.pawactive === 1) {
        this.$refs['updatePawForm'].validate((valid) => {
          if (valid) {
            this.nextBtn = '立即修改'
            this.pawactive = 2
            this.rulesUpdatePaw.password[0].required = true
            this.rulesUpdatePaw.refpassword[0].required = true
            this.$refs['updatePawForm'].clearValidate()
          } else {
            return false
          }
        })
      } else if (this.pawactive === 2) {
        this.$refs['updatePawForm'].validate((valid) => {
          if (valid) {
            const data = {
              username: this.updatePawForm.username,
              password: this.updatePawForm.password,
              msg_id: this.updatePawForm.msg_id,
              code: this.updatePawForm.code
            }
            forgetPassword(data).then(response => {
              if (!response.success) {
                this.$message({
                  type: 'error',
                  message: response.msg
                })
              } else {
                this.nextBtn = '下一步'
                this.pawactive = 0
                this.codeBtn = '重新获取 60'
                this.sounds = 60
                this.isDisabledCode = true
                clearInterval(this.codeTimer)
                this.rulesUpdatePaw.code[0].required = false
                this.rulesUpdatePaw.password[0].required = false
                this.rulesUpdatePaw.refpassword[0].required = false
                this.$refs['updatePawForm'].resetFields()
                this.$confirm('建议你重新登录一下，免得让我为难好吗?', '密码修改成功', {
                  confirmButtonText: '去登录',
                  cancelButtonText: '关闭',
                  type: 'success'
                }).then(() => {
                  this.$store.dispatch('user/logout')
                  this.$router.push(`/login`)
                }).catch(() => {
                })
              }
            }).catch(() => {
              this.isCodeLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    previousUpdatePaw() {
      if (this.pawactive !== 0) {
        if (this.pawactive === 2) {
          this.nextBtn = '下一步'
          this.rulesUpdatePaw.password[0].required = false
          this.rulesUpdatePaw.refpassword[0].required = false
        } else {
          this.rulesUpdatePaw.code[0].required = false
        }
        this.pawactive--
      }
    },
    getCode(isnext) {
      if (!this.isDisabledCode) {
        if (this.sounds === 60) {
          this.isCodeLoading = true
          getSMSCode(this.user.username).then(response => {
            this.isCodeLoading = false
            this.updatePawForm.msg_id = response.data.msg_id
            this.isDisabledCode = true
            this.codeTimer = setInterval(this.countdown, 1000)
            if (isnext === 1) {
              this.pawactive = 1
              this.rulesUpdatePaw.code[0].required = true
            }
          }).catch(() => {
            this.isCodeLoading = false
          })
        } else {
          this.isDisabledCode = true
          if (isnext === 1) {
            this.pawactive = 1
            this.rulesUpdatePaw.code[0].required = true
          }
        }
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.userinfo-container{
  .account-bind-list{
    width: 100%;
    position: relative;
    padding: 0;
    margin: 0;
    list-style: none;
    li{
      width: 160px;
      border:1px solid #f5f7fa;
      text-align: center;
      padding: 30px 10px;
      position: relative;
      float: left;
      margin: 20px 10px;
      .bind-icon{
        width: 54px;
        height: 54px;
        line-height: 54px;
        background: #409EFF;
        border-radius: 50%;
        margin: 0 auto;
        .svg-icon{
          color:#fff;
          width: 30px;
          height: 30px;
          margin-top: 12px;
        }
        &.wechat{
          background: #52aa38;
        }
        &.alipay{
          background: #459fe8;
        }
      }
      .bind-mark{
        padding: 20px 0;
        color:#999;
        font-size: 13px;
      }
      &:hover{
        box-shadow: rgba(99, 99, 99, 0.15) 0px 0px 4px 0px;
      }
    }
  }
}
</style>
